module.exports = __webpack_public_path__ + "static/media/YF94_2.44169169.jpg";